<template>
  <div class="user">
      <div class="photo" style="overflow: hidden; border-radius: 50%;font-size: 22px;text-align: center;line-height: 38px;color: #fff;font-family: 'SegoeUI-SemiLight-final','Segoe UI SemiLight','Segoe UI WPC Semilight','Segoe UI',Segoe,Tahoma,Helvetica,Arial,sans-serif;background-color: #084E79; outline-color: rgb(118, 118, 118);">
          {{ userInitials }}
      </div>
    <div class="info">
      <a data-toggle="collapse" :aria-expanded="!isClosed" @click="toggleMenu" href="#">
         <span>
           {{displayName}}
           <b class="caret"></b>
        </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <collapse-transition>
          <ul class="nav nav-menu" v-show="!isClosed">
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">Mp</span>
                <span class="sidebar-normal">My Profile</span>
              </a>
            </li>
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">Ep</span>
                <span class="sidebar-normal">Edit Profile</span>
              </a>
            </li>
            <li>
              <a href="#">
                <span class="sidebar-mini-icon">S</span>
                <span class="sidebar-normal">Settings</span>
              </a>
            </li>
          </ul>
        </collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import { CollapseTransition } from 'vue2-transitions';

  export default {
    components: {
      CollapseTransition
    },
    data() {
      return {
        isClosed: true
      }
    },
      computed: {
          oidcUser() {
              return this.$store.state.oidcStore.user;
          },
          displayName() {
              return this.oidcUser.given_name + ' ' + this.oidcUser.family_name
          },
          userInitials() {
              return this.oidcUser.given_name.substr(0, 1) + this.oidcUser.family_name.substr(0, 1);
          }
      },
    methods: {
      toggleMenu() {
        this.isClosed = !this.isClosed
      }
    },
      mounted() {
        console.log('User: ' + JSON.stringify(this.oidcUser));
      }
  }
</script>
<style scoped>
  .nav.nav-menu {
    margin-top: 0;
  }
</style>
